"use strict";
// ================================================================================================
exports.__esModule = true;
exports.FundInfoColumnList_StandardFund_List = exports.FundInfoColumnList_FundRules_List = exports.FundInfoColumnList_CustodianFund_List = exports.FundInfoColumnList_AccrualRules_List = exports.FundInfoColumnList = void 0;
var FundInfoColumnList;
(function (FundInfoColumnList) {
    // from DividendAccrualRateRules
    FundInfoColumnList["accrualRateRule"] = "accrualRateRule";
    FundInfoColumnList["accrualPeriodEnd"] = "accrualPeriodEnd";
    FundInfoColumnList["parentAccountRounding"] = "parentAccountRounding";
    // from CustodianFundInformation
    FundInfoColumnList["cusip"] = "cusip";
    FundInfoColumnList["fundStatus"] = "fundStatus";
    FundInfoColumnList["custodian12B1Fee"] = "custodian12B1Fee";
    FundInfoColumnList["subtaFee"] = "subtaFee";
    FundInfoColumnList["custodianBDServiceFee"] = "custodianBDServiceFee";
    FundInfoColumnList["subtaMethod"] = "subtaMethod";
    FundInfoColumnList["subtaPerParticipant"] = "subtaPerParticipant";
    FundInfoColumnList["clientFundSubtaBPSAgreement"] = "clientFundSubtaBPSAgreement";
    FundInfoColumnList["custodian12B1BPSFrequency"] = "custodian12B1BPSFrequency";
    FundInfoColumnList["custodian12B1BPSQuarterlyStart"] = "custodian12B1BPSQuarterlyStart";
    FundInfoColumnList["subtaBPSFrequency"] = "subtaBPSFrequency";
    FundInfoColumnList["subtaBPSQuarterlyStart"] = "subtaBPSQuarterlyStart";
    FundInfoColumnList["custodianServiceFeeBPSFrequency"] = "custodianServiceFeeBPSFrequency";
    FundInfoColumnList["custodianServiceFeeBPSQuarterlyStart"] = "custodianServiceFeeBPSQuarterlyStart";
    FundInfoColumnList["custodianQPMinPurchase"] = "custodianQPMinPurchase";
    // from FundRules
    FundInfoColumnList["fundStatusRules"] = "fundStatusRules";
    FundInfoColumnList["divType"] = "divType";
    FundInfoColumnList["divFrequency"] = "divFrequency";
    FundInfoColumnList["divAccrualPurchaseStart"] = "divAccrualPurchaseStart";
    FundInfoColumnList["divAccrualRedemptionStop"] = "divAccrualRedemptionStop";
    FundInfoColumnList["divAccrualPartialExchOutStop"] = "divAccrualPartialExchOutStop";
    FundInfoColumnList["divAccrualPartialExchInStart"] = "divAccrualPartialExchInStart";
    FundInfoColumnList["divAccrualPartialTransferOutStop"] = "divAccrualPartialTransferOutStop";
    FundInfoColumnList["divAccrualPartialTransferInStart"] = "divAccrualPartialTransferInStart";
    FundInfoColumnList["divAccrualAcatTransferOutStop"] = "divAccrualAcatTransferOutStop";
    FundInfoColumnList["divAccrualAcatTransferInStart"] = "divAccrualAcatTransferInStart";
    FundInfoColumnList["divDccsAccrualPurchaseStart"] = "divDccsAccrualPurchaseStart";
    FundInfoColumnList["divDccsAccrualRedemptionStop"] = "divDccsAccrualRedemptionStop";
    FundInfoColumnList["accrualWeekEndRule"] = "accrualWeekEndRule";
    FundInfoColumnList["accrualMonthEndRule"] = "accrualMonthEndRule";
    FundInfoColumnList["qpMinInitialPurchase"] = "qpMinInitialPurchase";
    FundInfoColumnList["qpMinSubsequentPurchase"] = "qpMinSubsequentPurchase";
    // from StandardFundInformation
    FundInfoColumnList["shareClass"] = "shareClass";
    FundInfoColumnList["_12B1Fee"] = "_12B1Fee";
    FundInfoColumnList["netExpenseRatio"] = "netExpenseRatio";
    FundInfoColumnList["grossExpenseRatio"] = "grossExpenseRatio";
    FundInfoColumnList["maxInitialSalesCharge"] = "maxInitialSalesCharge";
    FundInfoColumnList["maxDeferredSalesCharge"] = "maxDeferredSalesCharge";
    FundInfoColumnList["redemptionFees"] = "redemptionFees";
    FundInfoColumnList["managementFee"] = "managementFee";
    FundInfoColumnList["mstarId"] = "mstarId";
    FundInfoColumnList["mstarFundId"] = "mstarFundId";
    FundInfoColumnList["mstarAssetClass"] = "mstarAssetClass";
    FundInfoColumnList["mstarBroadCategoryGroup"] = "mstarBroadCategoryGroup";
    FundInfoColumnList["mstarCategoryCode"] = "mstarCategoryCode";
    FundInfoColumnList["mstarPrimaryIndexId"] = "mstarPrimaryIndexId";
    FundInfoColumnList["mstarSecondaryIndexId"] = "mstarSecondaryIndexId";
})(FundInfoColumnList = exports.FundInfoColumnList || (exports.FundInfoColumnList = {}));
// ================================================================================================
// lists from above .. be sure to add to both places
// ================================================================================================
exports.FundInfoColumnList_AccrualRules_List = [
    // from DividendAccrualRateRules
    FundInfoColumnList.accrualRateRule,
    FundInfoColumnList.accrualPeriodEnd,
    FundInfoColumnList.parentAccountRounding,
];
// from CustodianFundInformation
exports.FundInfoColumnList_CustodianFund_List = [
    FundInfoColumnList.cusip,
    FundInfoColumnList.fundStatus,
    FundInfoColumnList.custodian12B1Fee,
    FundInfoColumnList.subtaFee,
    FundInfoColumnList.custodianBDServiceFee,
    FundInfoColumnList.subtaMethod,
    FundInfoColumnList.subtaPerParticipant,
    FundInfoColumnList.clientFundSubtaBPSAgreement,
    FundInfoColumnList.custodian12B1BPSFrequency,
    FundInfoColumnList.custodian12B1BPSQuarterlyStart,
    FundInfoColumnList.subtaBPSFrequency,
    FundInfoColumnList.subtaBPSQuarterlyStart,
    FundInfoColumnList.custodianServiceFeeBPSFrequency,
    FundInfoColumnList.custodianServiceFeeBPSQuarterlyStart,
    FundInfoColumnList.custodianQPMinPurchase,
];
// from FundRules
exports.FundInfoColumnList_FundRules_List = [
    FundInfoColumnList.fundStatusRules,
    FundInfoColumnList.divType,
    FundInfoColumnList.divFrequency,
    FundInfoColumnList.divAccrualPurchaseStart,
    FundInfoColumnList.divAccrualRedemptionStop,
    FundInfoColumnList.divAccrualPartialExchOutStop,
    FundInfoColumnList.divAccrualPartialExchInStart,
    FundInfoColumnList.divAccrualPartialTransferOutStop,
    FundInfoColumnList.divAccrualPartialTransferInStart,
    FundInfoColumnList.divAccrualAcatTransferOutStop,
    FundInfoColumnList.divAccrualAcatTransferInStart,
    FundInfoColumnList.divDccsAccrualPurchaseStart,
    FundInfoColumnList.divDccsAccrualRedemptionStop,
    FundInfoColumnList.accrualWeekEndRule,
    FundInfoColumnList.accrualMonthEndRule,
    FundInfoColumnList.qpMinInitialPurchase,
    FundInfoColumnList.qpMinSubsequentPurchase,
];
// from StandardFundInformation
exports.FundInfoColumnList_StandardFund_List = [
    FundInfoColumnList.shareClass,
    FundInfoColumnList._12B1Fee,
    FundInfoColumnList.netExpenseRatio,
    FundInfoColumnList.grossExpenseRatio,
    FundInfoColumnList.maxInitialSalesCharge,
    FundInfoColumnList.maxDeferredSalesCharge,
    FundInfoColumnList.redemptionFees,
    FundInfoColumnList.managementFee,
    FundInfoColumnList.mstarId,
    FundInfoColumnList.mstarFundId,
    FundInfoColumnList.mstarAssetClass,
    FundInfoColumnList.mstarBroadCategoryGroup,
    FundInfoColumnList.mstarCategoryCode,
    FundInfoColumnList.mstarPrimaryIndexId,
    FundInfoColumnList.mstarSecondaryIndexId,
];
